module.exports = __webpack_public_path__ + "img/xml.4f1ac528.png";